"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageHistoryPage = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var FilterTabs_1 = require("../components/FilterTabs");
var PackageSearchInput_1 = require("../components/PackageSearchInput");
var Page_1 = require("@app/components/layout/Page");
// import UserFilter from '@app/features/package-history/components/UserFilter';
var ReceivedPackages_1 = __importDefault(require("@app/features/received-packages/components/ReceivedPackages"));
var actions_1 = require("@app/features/received-packages/state/actions");
var SentPackages_1 = __importDefault(require("@app/features/sent-packages/components/SentPackages"));
var actions_2 = require("@app/features/sent-packages/state/actions");
var selectors_1 = require("@app/features/transfers/state/selectors");
var config_1 = require("@app/shared/config");
var initialState = {};
var PackageHistoryPage = /** @class */ (function (_super) {
    __extends(PackageHistoryPage, _super);
    function PackageHistoryPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleSearchInputChange = function (searchTerm) {
            _this.setState({ searchTerm: searchTerm });
        };
        if (props.locationAction === 'POP') {
            _this.state = {
                searchTerm: _this.props.savedSearchTerm ? _this.props.savedSearchTerm : ''
            };
        }
        else {
            _this.state = {
                searchTerm: ''
            };
        }
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    PackageHistoryPage.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.match.params.mailbox !== this.props.match.params.mailbox) {
            this.setState({ searchTerm: '' });
        }
    };
    /* // Removed as part of AOTDEV-325 and left in case it's wanted to be put back
    private handleSelectUser = (userIdentifier: string) => {
      if (this.props.match.params.mailbox === 'received') {
        this.props.onFilterSender(userIdentifier);
      } else {
        this.props.onFilterRecipient(userIdentifier);
      }
    }
    */
    /* Component Methods - Begin */
    PackageHistoryPage.prototype.render = function () {
        var activeTab = this.props.match.params.mailbox;
        /* // Removal of user filter properties
        const {
          receivedPackagesUserFilters,
          receivedPackagesSelectedUsers,
          sentPackagesUserFilters,
          sentPackagesSelectedUsers
        } = this.props;
        const userFilters = activeTab === 'received' ? receivedPackagesUserFilters : sentPackagesUserFilters;
        const selectedUsers = activeTab === 'received' ? receivedPackagesSelectedUsers : sentPackagesSelectedUsers;
        */
        return (react_1.default.createElement(Page_1.Page, { title: "Package History", isAsperaInitializing: this.props.asperaInitializing, isLoading: !this.props.asperaLoaded },
            react_1.default.createElement("div", { className: "level" },
                react_1.default.createElement("div", { className: "level-left" },
                    react_1.default.createElement("div", { className: "level-item" },
                        react_1.default.createElement(PackageSearchInput_1.PackageSearchInput, { onChange: this.handleSearchInputChange, placeholder: "Search " + String(activeTab).replace(/^./, String(activeTab).charAt(0).toUpperCase()) + "...", value: this.state.searchTerm }))),
                react_1.default.createElement("div", { className: "level-right" },
                    react_1.default.createElement("div", { className: "level-item" },
                        react_1.default.createElement(FilterTabs_1.FilterTabs, { activeTab: activeTab, view: 'history' })))),
            activeTab === 'received' &&
                react_1.default.createElement(ReceivedPackages_1.default, { searchTerm: this.state.searchTerm, downloadSizeLimitInMB: config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE, pageSize: config_1.Config.DEFAULT_PAGE_SIZE }),
            activeTab === 'sent' &&
                react_1.default.createElement(SentPackages_1.default, { searchTerm: this.state.searchTerm, pageSize: config_1.Config.DEFAULT_PAGE_SIZE })));
    };
    return PackageHistoryPage;
}(react_1.Component));
exports.PackageHistoryPage = PackageHistoryPage;
var mapStateToProps = function (store) {
    return {
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        asperaLoaded: selectors_1.isAsperaLoaded(store),
        locationAction: store.router.action,
        receivedPackagesUserFilters: store.receivedPackages.userFilters,
        receivedPackagesSelectedUsers: store.receivedPackages.selectedUsers,
        savedSearchTerm: store.packageDetails.savedSearchTerm,
        sentPackagesUserFilters: store.sentPackages.userFilters,
        sentPackagesSelectedUsers: store.sentPackages.selectedUsers
    };
};
var mapDispatchToProps = {
    onFilterRecipient: actions_2.toggleSelectUser,
    onFilterSender: actions_1.toggleSelectUser,
    receivedIsSearching: actions_1.setIsSearching,
    sentIsSearching: actions_2.setIsSearching
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PackageHistoryPage);
